import { FirestoreDataConverter, Timestamp } from '@angular/fire/firestore';

/**
 * Late order alert judged unjustified, hidden until its lateness conditions change
 */
export class PlanningLateAck {
  id: string;
  organizationId: string;
  jobNumber: number;
  /** Lateness conditions when acknowledged, see lateOrderSignature */
  signature: string;
  acknowledgedBy: string;
  acknowledgedAt: Date | null;

  constructor(ack?: Partial<PlanningLateAck>) {
    this.id = ack?.id ?? '';
    this.organizationId = ack?.organizationId ?? '';
    this.jobNumber = ack?.jobNumber ?? 0;
    this.signature = ack?.signature ?? '';
    this.acknowledgedBy = ack?.acknowledgedBy ?? '';
    this.acknowledgedAt = ack?.acknowledgedAt ?? null;
  }

  /**
   * Converter used to read and write late order acknowledgements
   */
  static converter: FirestoreDataConverter<PlanningLateAck> = {
    toFirestore: (ack: PlanningLateAck) => ({
      organizationId: ack.organizationId,
      jobNumber: ack.jobNumber,
      signature: ack.signature,
      acknowledgedBy: ack.acknowledgedBy,
      acknowledgedAt: ack.acknowledgedAt,
    }),
    fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return new PlanningLateAck({
        ...data,
        id: snapshot.id,
        jobNumber: Number(data['jobNumber']) || 0,
        acknowledgedAt: (data['acknowledgedAt'] as Timestamp)?.toDate() ?? null,
      });
    },
  };
}
